import { pushRetryableEvent } from "./utils";

export default {
    mounted() {
        this.mediaRecorder = null;
        this.audioChunks = [];
        this.isRecording = false;
        this.isStarting = false;
        this.mimeType = this.getSupportedMimeType();
        this.stream = null;

        this.el.addEventListener("click", async () => {
            if (this.isStarting) return;

            if (!this.isRecording) {
                await this.startRecording();
            } else {
                this.stopRecording();
            }
        });
    },

    getSupportedMimeType() {
        const types = [
            "audio/mp4",
            "audio/webm;codecs=opus",
            "audio/webm",
            "audio/mpeg",
            "audio/ogg;codecs=opus",
            "audio/ogg",
        ];

        for (const type of types) {
            if (MediaRecorder.isTypeSupported(type)) {
                return type;
            }
        }

        return "";
    },

    getFileExtension(mimeType) {
        const mimeToExt = {
            "audio/webm": "weba",
            "audio/webm;codecs=opus": "weba",
            "audio/mp4": "m4a",
            "audio/mpeg": "mp3",
            "audio/ogg": "ogg",
            "audio/ogg;codecs=opus": "ogg",
        };

        return mimeToExt[mimeType] || "m4a";
    },

    async startRecording() {
        this.isStarting = true;
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            const options = this.mimeType ? { mimeType: this.mimeType } : {};
            this.mediaRecorder = new MediaRecorder(this.stream, options);
            this.audioChunks = [];

            this.mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    this.audioChunks.push(event.data);
                }
            };

            this.mediaRecorder.onerror = (event) => {
                console.error("MediaRecorder error:", event.error);
            };

            this.mediaRecorder.onstop = async () => {
                const actualMimeType = this.mediaRecorder.mimeType || this.mimeType || "audio/mp4";
                const audioBlob = new Blob(this.audioChunks, { type: actualMimeType });

                this.uploadAudio(audioBlob, actualMimeType);
            };

            this.mediaRecorder.start(100);
            this.isRecording = true;
            this.el.classList.add("recording");
            pushRetryableEvent(this, "recording_started");
        } catch (error) {
            console.error("Error accessing microphone:", error);
            pushRetryableEvent(this, "recording_error", { error: error.message });
        } finally {
            this.isStarting = false;
        }
    },

    stopRecording() {
        if (this.mediaRecorder && this.isRecording) {
            this.mediaRecorder.stop();
            if (this.stream) {
                this.stream.getTracks().forEach((track) => track.stop());
            }
            this.isRecording = false;
            this.el.classList.remove("recording");
            pushRetryableEvent(this, "recording_stopped");
        }
    },

    uploadAudio(audioBlob, mimeType) {
        const extension = this.getFileExtension(mimeType);
        const file = new File([audioBlob], `audio_${Date.now()}.${extension}`, {
            type: mimeType,
            lastModified: Date.now(),
        });

        const input = document.querySelector('input[type="file"][name="audio"]');
        if (input) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            input.files = dataTransfer.files;

            const event = new Event("change", { bubbles: true });
            input.dispatchEvent(event);
        }
    },

    destroyed() {
        if (this.isRecording) {
            this.stopRecording();
        }
        if (this.stream) {
            this.stream.getTracks().forEach((track) => track.stop());
            this.stream = null;
        }
    },
};
